module.exports = __webpack_public_path__ + "static/media/play_on_middle_icon.92aac091.svg";